import { signalStoreFeature, withState } from '@ngrx/signals';
import { withCallState, withListState } from '@aston/foundation';

import { ICompletedAccountingListItem, IImportErrorColumnRowModel, IImportFileReportErrorLineItem } from '../../models';
import { CompletedAccountingListSortProp, ImportReportErrorColumnsListSortProp, ImportReportErrorLinesListSortProp } from '../../enums';

import { IImportDetailStoreInitialState } from './import-detail.store';

const IMPORT_ITEM = 'importItem';
const SELECTED_FILES = 'selectedFiles';
const IMPORT_CONFIG = 'importConfiguration';
const RECOVERY_ADVISORS = 'recoveryAdvisors';

const REPORT_ERROR_COLUMNS = 'reportErrorColumns';
const REPORT_ERROR_LINES = 'reportErrorLines';
const COMPLETED_ACCOUNTING = 'completedAccounting';

export function withImportDetailStates<_>(initialState: IImportDetailStoreInitialState) {
	return signalStoreFeature(
		{},

		withState(initialState),

		withCallState({ collection: IMPORT_ITEM }),
		withCallState({ collection: SELECTED_FILES }),
		withCallState({ collection: IMPORT_CONFIG }),
		withCallState({ collection: RECOVERY_ADVISORS }),
		
		withListState<IImportErrorColumnRowModel, ImportReportErrorColumnsListSortProp, typeof REPORT_ERROR_COLUMNS>({
			collection: REPORT_ERROR_COLUMNS,
			defaultSort: [
				{ prop: ImportReportErrorColumnsListSortProp.ERROR_COUNT, isDesc: true },
				{ prop: ImportReportErrorColumnsListSortProp.STATUS, isDesc: true }
			],
		}),

		withListState<IImportFileReportErrorLineItem, ImportReportErrorLinesListSortProp, typeof REPORT_ERROR_LINES>({
			collection: REPORT_ERROR_LINES,
			defaultSort: [{prop: ImportReportErrorLinesListSortProp.LINE, isDesc: false}]
		}),

		withListState<ICompletedAccountingListItem, CompletedAccountingListSortProp, typeof COMPLETED_ACCOUNTING>({
			collection: COMPLETED_ACCOUNTING,
			defaultSort: [{ prop: CompletedAccountingListSortProp.FactorIdentifier, isDesc: false }],
		}),
	)
}